import { render, staticRenderFns } from "./ForumPostAdmin.vue?vue&type=template&id=4decde7e&scoped=true"
import script from "./ForumPostAdmin.vue?vue&type=script&lang=js"
export * from "./ForumPostAdmin.vue?vue&type=script&lang=js"
import style0 from "./ForumPostAdmin.vue?vue&type=style&index=0&id=4decde7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4decde7e",
  null
  
)

export default component.exports